import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { LINE_OF_BUSINESS_ENUM } from '@ptl/account-management';
import { SavedQuotesStateStructure } from 'src/app/angular-elements/producer/saved-quotes/interfaces/savedQuotesStateStructure.interface';
import { SAVED_QUOTES_REDUCER_NAME } from 'src/app/angular-elements/producer/saved-quotes/reducers/saved-quotes.reducer';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { EnrollmentAppStateStructure } from '../../interfaces/enrollmentAppStateStructure.interface';
import { ENROLLMENT_APP_STATE_NAME } from 'src/app/shared/reducers/enrollmentApp.reducer';

@Component({
  selector: 'app-doc-upload-success',
  templateUrl: './doc-upload-success.component.html',
  styleUrl: './doc-upload-success.component.scss',
  standalone: false,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class DocUploadSuccessComponent implements OnInit {
  @Input() nextPageUrl: string;
  @Input() lineOfBusiness: LINE_OF_BUSINESS_ENUM;
  
  contentInfo = {
    qualifyingLifeEvent: null,
    dateOfLifeEvent: null,
    effectiveDate: null,
    appId: null
  }

  constructor(
    private reducerUtilityService: ReducerUtilityService
  ) {}

  ngOnInit(): void {
    const state: SavedQuotesStateStructure = this.reducerUtilityService.getComponentStates()[SAVED_QUOTES_REDUCER_NAME];
    this.contentInfo.effectiveDate = state.saveQuoteData.state.payloadStates.individualMarket.ratingInfo.effectiveDate;
    this.contentInfo.qualifyingLifeEvent = state.saveQuoteData.state.payloadStates['special-enrollment-circumstance'].lifeEvent.portalTypeDescription;
    this.contentInfo.dateOfLifeEvent = state.saveQuoteData.state.payloadStates['special-enrollment-circumstance'].dateOfLifeEvent;
    const enrollmentState: EnrollmentAppStateStructure = this.reducerUtilityService.getComponentStates()[ENROLLMENT_APP_STATE_NAME];
    this.contentInfo.appId = enrollmentState.appId;
  }

}
